import { createSelector } from 'reselect';
import * as AppSelectors from 'src/redux/modules/applicationData/applicationData.selectors';
import * as executeAutoExchange from 'src/redux/modules/executeAutoExchange/selectors';
import * as exchangeTransaction from 'src/redux/modules/exchangeTransaction/selectors';

export const isLoaderVisible = createSelector(
  [
    AppSelectors.getIsLoading,
    AppSelectors.getAppLoaded,
    executeAutoExchange.getIsLoading,
    AppSelectors.getHasFailed,
  ],
  (appLoading, hasLoaded, exchangeLoading, hasFailed) => {
    return (!hasLoaded && !hasFailed) || appLoading || exchangeLoading;
  }
);

export const isExecutionLoading = executeAutoExchange.getIsLoading;

export const shouldResetScrollPosition = createSelector(
  [
    executeAutoExchange.getValidationFailed,
    exchangeTransaction.getExchangeToExistingLoadFailed,
    executeAutoExchange.getHasFailed,
  ],
  (validationFailed, loadFailed, hasFailed) =>
    validationFailed || loadFailed || hasFailed
);
